module.exports = __webpack_public_path__ + "img/happy.4a261937.jpeg";